import { useGetCarbonProgramByFarmId } from "utils";

import { DAIRY_METHODOLOGY } from "models";

export const useDairyMethodology = (farmId?: string) => {
  const { data } = useGetCarbonProgramByFarmId(farmId);
  // Programs without a dairy methodology are calculated with LfL by the API
  const dairy = data?.farmLevelFootprinting?.methodology?.dairy ?? DAIRY_METHODOLOGY.LFL;
  return {
    isLfl: dairy === DAIRY_METHODOLOGY.LFL,
    isCfp: dairy === DAIRY_METHODOLOGY.CFP,
  };
};
